<template>
	<div class="product-list">
		<div class="common-seach-wrap">
			<el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item label="场景名称">
					<el-input size="small" v-model="searchForm.sence_name" placeholder="请输入场景名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--添加产品-->
		<div class="common-level-rail" style="display:flex;">
			<el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加极光场景</el-button>
		</div>
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="tableData" border style="width: 100%">

					<el-table-column prop="sence_name" align="center" label="场景名称">
					</el-table-column>
					<el-table-column prop="status" label="启用状态" align="center">
						<template slot-scope="scope">
							<el-switch class="switch" @change='isShow(scope.row)' v-model="scope.row.status"
								:active-value="1" :inactive-value="0" active-text="是" inactive-text="否">
							</el-switch>
						</template>
					</el-table-column>

					<el-table-column fixed="right" label="操作" align="center" width="180">
						<template slot-scope="scope">
							<el-button @click="editClick(scope.row)" type="primary" size="small">编辑</el-button>
							<el-button @click="delClick(scope.row)" type="danger" size="small">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagination">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
				:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				:total="totalDataNumber"></el-pagination>
		</div>
	</div>
</template>

<script>
	import AppSettingApi from "@/api/appsetting.js";
	export default {
		components: {
			// Add
		},
		data() {
			return {
				status: "", //是否显示
				tableData: [],
				open_add: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				searchForm: {
					sence_name: ""
				}
			};
		},
		created() {
			/*获取列表*/
			this.getData();
		},
		methods: {
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.loading = true;
				self.curPage = val;
				self.getData();
			},
			/*每页多少条*/
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			// 是否显示音乐
			isShow(row) {
				let self = this;
				AppSettingApi.senceStatus({
					sence_id: row.sence_id,
					status: row.status
				}).then(data => {
					self.$message({
						message: "修改成功",
						type: "success"
					});
					self.getData();
				});
			},
			/*打开添加*/
			addClick() {
				this.$router.push("/appsetting/jgpush/add");
			},
			// 详情
			getData() {
				let self = this;
				let Params = self.searchForm;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				AppSettingApi.senceList(Params, true)
					.then(data => {
						self.tableData = data.data.list.data;
						self.totalDataNumber = data.data.list.total;
					})
					.catch(error => {
						// self.loading = false;
					});
			},
			/*打开编辑*/
			editClick(row) {
				this.$router.push({
					path: "/appsetting/jgpush/edit",
					query: {
						sence_id: row.sence_id,
						scene: "edit"
					}
				});
			},
			/*删除*/
			delClick: function(row) {
				let self = this;
				self
					.$confirm("确定删除该记录吗?", "提示", {
						type: "warning"
					})
					.then(() => {
						AppSettingApi.senceDel({
							sence_id: row.sence_id
						}).then(data => {
							self.$message({
								message: "删除成功",
								type: "success"
							});
							self.getData();
						});
					});
			}
		}
	};
</script>

<style scoped lang='scss'>
	.s_flex {
		display: flex;
		justify-content: space-between;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/appsetting/jgpush/index.vue